module.exports = __webpack_public_path__ + "img/Award.c6b1097e.png";